import { createApp } from "vue";
import { createPinia } from "pinia";
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client/core";
import { DefaultApolloClient, provideApolloClient } from "@vue/apollo-composable";
import { setContext } from "@apollo/client/link/context";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import VueClickAway from "vue3-click-away";

import FileManager from "~/vue/FileManager.vue";

// Main app
const fileManager = async () => {
	const pinia = createPinia();
	const app = createApp(FileManager);

	const httpLink = createHttpLink({
		uri: import.meta.env.VITE_GQL_URL ?? `${window.location.origin}/api`,
	});

	const authLink = setContext((_, { headers }) => {
		return {
			headers: {
				...headers,
				authorization: `Bearer ${import.meta.env.VITE_GQL_TOKEN ?? ""}`,
			},
		};
	});

	// Create the apollo client
	const apolloProvider = new ApolloClient({
		link: authLink.concat(httpLink),
		cache: new InMemoryCache(),
	});

	provideApolloClient(apolloProvider);
	app.provide(DefaultApolloClient, apolloProvider);

	pinia.use(piniaPluginPersistedstate);

	app.use(VueClickAway);
	app.use(pinia);

	return app.mount("#file-manager");
};

// Execute async function
fileManager().then(() => {
	console.log();
});
